import clientAuth from "../clientAuth";
import client from "../client";
export default {
  // get camper 
  

  index: () => clientAuth.get("booking-details/index"),
  
  store: (userData) => clientAuth.post('booking-details/store', { json: userData }),

  show:(id)=>clientAuth.get('booking-details/show/'+id),

  update:(id,userData)=>clientAuth.post(`booking-details/update/${id}`,{json:userData}),

  destroy:(id)=>clientAuth.delete(`booking-details/destroy/${id}`),
  
  getusers:()=>clientAuth.get('booking-details/getusers'),

  register:(userData)=>clientAuth.post('booking-details/createuser', { json: userData }),

  personalstore: (userData) => clientAuth.post('booking-details/personalstore', { json: userData }),
};